<template>
  <div class="fe-safe-area">
    <div class="fe-safe-area-top-bg"></div>
    <div class="fe-safe-area-bottom-bg"></div>
    <van-config-provider>
      <div class="app-layout">
        <router-view v-slot="{ Component, route }">
          <template v-if="Component">
            <transition :name="router.customRouterData?.transitionName" :css="routerAnimation" :duration="300" appear>
              <keep-alive :max="10" :include="keepAliveRouter">
                <suspense>
                  <component :is="Component" :key="decodeURIComponent(route.fullPath)"></component>
                </suspense>
              </keep-alive>
            </transition>
          </template>
        </router-view>
      </div>
    </van-config-provider>
  </div>
</template>
<script setup lang="ts">
import { computed, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { useGlobalStore } from '@/store/globalStore';

const router = useRouter();
const globalStore = useGlobalStore();

const keepAliveRouter = computed(() => globalStore.keepAliveRouter);
const routerAnimation = computed(() => globalStore.routerAnimation);

onMounted(() => {
  // 获取四周安全区距离 并记录到html标签上
  const sat = getComputedStyle(document.documentElement).getPropertyValue('--sat');
  const sar = getComputedStyle(document.documentElement).getPropertyValue('--sar');
  const sab = getComputedStyle(document.documentElement).getPropertyValue('--sab');
  const sal = getComputedStyle(document.documentElement).getPropertyValue('--sal');
  const top = parseInt(sat) || 0,
    right = parseInt(sar) || 0,
    bottom = parseInt(sab) || 0,
    left = parseInt(sal) || 0;

  document.documentElement.setAttribute('sat', top.toString());
  document.documentElement.setAttribute('sar', right.toString());
  document.documentElement.setAttribute('sab', bottom.toString());
  document.documentElement.setAttribute('sal', left.toString());

  if (top !== 0) {
    document.documentElement.classList.add('has-sat');
  }
  if (right !== 0) {
    document.documentElement.classList.add('has-sar');
  }
  if (bottom !== 0) {
    document.documentElement.classList.add('has-sab');
  }
  if (left !== 0) {
    document.documentElement.classList.add('has-sal');
  }
});
</script>

<style lang="postcss">
#app {
  height: 100vh;
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  box-sizing: border-box;

  .fe-safe-area {
    height: 100vh;
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;
    position: relative;
    background: var(--base-fe-safe-area-background);
    box-sizing: border-box;
    padding-top: constant(safe-area-inset-top);
    padding-top: env(safe-area-inset-top);
    padding-bottom: constant(safe-area-inset-bottom);
    padding-bottom: env(safe-area-inset-bottom);
    padding-left: constant(safe-area-inset-left);
    padding-left: env(safe-area-inset-left);
    padding-right: constant(safe-area-inset-right);
    padding-right: env(safe-area-inset-right);
    .fe-safe-area-top-bg {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: constant(safe-area-inset-top);
      height: env(safe-area-inset-top);
      background: var(--base-fe-safe-area-top-background);
      transition: all 0.3s;
    }
    .fe-safe-area-bottom-bg {
      position: absolute;
      left: 0;
      bottom: 0;
      width: 100%;
      height: constant(safe-area-inset-bottom);
      height: env(safe-area-inset-bottom);
      background: var(--base-fe-safe-area-bottom-background);
      transition: all 0.3s;
    }
  }
  .van-config-provider {
    height: 100%;
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;
    .app-layout {
      position: relative;
      height: 100%;
      display: flex;
      flex-direction: column;
      flex: 1 1 auto;
    }
  }
}

/* 路由动画 */
.slide_left-enter-active,
.slide_left-leave-active,
.slide_right-enter-active,
.slide_right-leave-active {
  transition: all 0.3s;
  position: absolute !important;
  background-color: white;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 1;
}
.slide_left-enter-active {
  z-index: 2;
}

.slide_left-enter-from {
  transform: translateX(100%);
}
.slide_left-leave-from {
  opacity: 1;
}
.slide_left-leave-to {
  opacity: 0.3;
}

.slide_right-enter-from {
  opacity: 1;
  transform: translateX(-100%);
}
.slide_right-leave-to {
  opacity: 0.3;
}
</style>
